import axios from "axios";
import url from "../config/urlServiceConfig";

const taskCenterAPI = {
  getUpdateKPI: () => axios.get(`${url.taskCenter}/UpdateKPI`),
  getMyTasks: () => axios.get(`${url.taskCenter}/UserTasks`),
  getMyRequests: () => axios.get(`${url.taskCenter}/UserRequests`),
  getArchive: () => axios.get(`${url.taskCenter}/UserArchive`),
  getCalenderData: (body) => axios.post(`${url.taskCenter}/Calendar`, body),
  getTasksCount: () => axios.get(`${url.taskCenter}/TasksCount`),
  readTask: (body) => axios.post(`${url.taskCenter}/ReadTask`, body),
};

export default taskCenterAPI;
